export default __webpack_public_path__ + "media/images/hero-0283c15df86dae05c172ebc44442ce62.jpg";